export function LoadingSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading content" className="space-y-4">
      <div className="h-5 w-40 animate-pulse rounded-control bg-surface-muted motion-reduce:animate-none" />
      <div className="h-20 w-full animate-pulse rounded-panel bg-surface-muted motion-reduce:animate-none" />
      <div className="h-20 w-4/5 animate-pulse rounded-panel bg-surface-muted motion-reduce:animate-none" />
    </div>
  );
}
